import Moment from 'moment'

export const fileNameWithDate = (name = '', moment = Moment()) => `${name} (${moment.format('DD MMM YYYY')}).csv`


// WEBPACK FOOTER //
// ./src/io/download-csv/helper.js